import { useCallback, useRef, useEffect } from "react";
import _ from "lodash";

type AnyFunction = (...args: any[]) => void;

export function useDebouncedCallback<T extends AnyFunction>(
  callback: T,
  delay: number,
  deps: any[] = [],
): (...args: Parameters<T>) => void {
  const callbackRef = useRef<T>(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFn = useCallback(
    _.debounce((...args: Parameters<T>) => {
      callbackRef.current(...args);
    }, delay),
    [delay, ...deps],
  );

  useEffect(() => {
    return () => {
      debouncedFn.cancel();
    };
  }, [debouncedFn]);

  return debouncedFn;
}
